<script setup lang="ts">
defineProps<{
  type: 'success' | 'error' | 'warning'
}>()

const colorMap = { success: 'bg-green-lighter', error: 'bg-red-lighter', warning: 'bg-yellow-lighter' }
</script>

<template>
  <div
    role="alert"
    :data-test="`alert-${type}`"
    :data-type="type"
    class="p-3 text-center rounded-md"
    :class="colorMap[type]"
  >
    <slot></slot>
  </div>
</template>
